import type { ComponentPropsWithRef, ReactElement } from 'react';
import { cn } from '../util/classes.ts';

export type ListViewProps = ComponentPropsWithRef<'div'>;

export function ListView({ className, ...props }: ListViewProps): ReactElement {
    return (
        <div
            data-slot="list-view"
            className={cn('flex min-h-0 w-full grow flex-col', className)}
            {...props}
        />
    );
}

export type ListViewHeaderProps = ComponentPropsWithRef<'header'>;

export function ListViewHeader({ className, ...props }: ListViewHeaderProps): ReactElement {
    return (
        <header
            data-slot="list-view-header"
            className={cn('flex shrink-0 flex-col gap-default px-relaxed pt-page pb-default', className)}
            {...props}
        />
    );
}

export type ListViewBodyProps = ComponentPropsWithRef<'div'>;

export function ListViewBody({ className, ...props }: ListViewBodyProps): ReactElement {
    return (
        <div data-slot="list-view-body" className={cn('flex min-h-0 grow flex-col', className)} {...props} />
    );
}
